import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Privacy = () => {
  return (
    <>
      <Header />
      <div className="page-offset policy-offset">
      <section className="privacy-policy">
        <div className="container">
          <h1 className="h1 section-title">Privacy Policy</h1>
          <div className="privacy-content">
            <p className="privacy-intro">
              <strong>Oracle Gaming</strong> is committed to protecting your privacy and ensuring the security of your personal information. 
              This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or make purchases from our gaming store.
            </p>

            <div className="privacy-section">
              <h2 className="h2">Information We Collect</h2>
              <h3 className="h3">Personal Information</h3>
              <p>When you make a purchase or create an account, we may collect:</p>
              <ul>
                <li>Name and contact information (email address, phone number)</li>
                <li>Billing and shipping addresses</li>
                <li>Payment information (processed securely through our payment partners)</li>
                <li>Account credentials and preferences</li>
              </ul>

              <h3 className="h3">Automatically Collected Information</h3>
              <p>We automatically collect certain information when you visit our website:</p>
              <ul>
                <li>IP address and browser information</li>
                <li>Pages visited and time spent on our site</li>
                <li>Device information and operating system</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2 className="h2">How We Use Your Information</h2>
              <p>We use your information to:</p>
              <ul>
                <li>Process and fulfill your orders for trading cards, gaming accessories, and merchandise</li>
                <li>Provide customer support and respond to your inquiries</li>
                <li>Send order confirmations, shipping updates, and delivery notifications</li>
                <li>Improve our website functionality and user experience</li>
                <li>Send promotional emails about new products, tournaments, and special offers (with your consent)</li>
                <li>Comply with legal obligations and protect against fraud</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2 className="h2">Information Sharing</h2>
              <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
              <ul>
                <li><strong>Service Providers:</strong> With trusted third parties who help us operate our business (payment processors, shipping companies, email services)</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
                <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets</li>
                <li><strong>Consent:</strong> When you have given us explicit permission to share your information</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2 className="h2">Data Security</h2>
              <p>
                We implement appropriate security measures to protect your personal information against unauthorized access, 
                alteration, disclosure, or destruction. This includes:
              </p>
              <ul>
                <li>SSL encryption for all data transmission</li>
                <li>Secure payment processing through certified providers</li>
                <li>Regular security audits and updates</li>
                <li>Limited access to personal information on a need-to-know basis</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2 className="h2">Cookies and Tracking</h2>
              <p>
                We use cookies and similar technologies to enhance your browsing experience, remember your preferences, 
                and analyze website traffic. You can control cookie settings through your browser preferences.
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="h2">Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access and review your personal information</li>
                <li>Correct inaccurate or incomplete information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent for data processing</li>
              </ul>
              <p>
                To exercise these rights, please contact us at <a href="mailto:privacy@oraclegaming.co.za">privacy@oraclegaming.co.za</a>
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="h2">Children's Privacy</h2>
              <p>
                Our services are not directed to children under 13 years of age. We do not knowingly collect personal 
                information from children under 13. If you are a parent or guardian and believe your child has provided 
                us with personal information, please contact us immediately.
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="h2">Third-Party Links</h2>
              <p>
                Our website may contain links to third-party websites, including gaming communities, tournament organizers, 
                and partner stores. We are not responsible for the privacy practices of these external sites. 
                We encourage you to review their privacy policies before providing any personal information.
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="h2">Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. 
                We will notify you of any material changes by posting the updated policy on our website and updating the "Last Updated" date below.
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="h2">Contact Information</h2>
              <p>
                If you have any questions about this Privacy Policy or our data practices, please contact us:
              </p>
              <div className="contact-info">
                <p><strong>Oracle Gaming</strong></p>
                <p>Email: <a href="mailto:oraclegaming.za@gmail.com">oraclegaming.za@gmail.com</a></p>
                <p>Phone: <a href="tel:+2782 565 5408">+27 82 565 5408</a></p>
                <p>Address: 11a President Steyn Ave, Westdene, Bloemfontein, 9301</p>
              </div>
            </div>

            <div className="privacy-footer">
              <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-ZA', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            </div>
          </div>
        </div>
      </section>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;
